export enum PackageItemItemType {
    PackageItem = "package_item",
    Upsell = "upsell",
}
